// stationReport.js
// -----------------------------------------------------------------------------
// A driver's report of an EV charger or an NGV gas station, validated before it
// is stored.
//
// Petrol is deliberately NOT a kind. Every fuel station in the country sells it,
// so a report of one carries no information; the five NGV vehicles in
// scripts/seed-car-info.js are the ones that can be stranded, and NGV stations are
// scarce. 'gas' therefore means NGV -- the same sense dispatchPlan.js uses when it
// labels a refuel stop 'เติมแก๊ส' for fuelType 'ngv'.
//
// This is a REVIEW QUEUE, not an edit to chargers.js. That table is
// hand-maintained on purpose: its header explains that the ten stations on it
// were chosen because they have no queue, which is operational knowledge no
// public dataset carries. A report is a candidate. A person still edits
// CHARGERS and redeploys.
//
// Pure: no Vue, no Firestore, CommonJS.
// -----------------------------------------------------------------------------

const KINDS = ['ev', 'gas']

// A generous box around Thailand. The point is not cartographic precision -- it
// is catching 0,0, which is what a failed GPS read produces and which sits in
// the Gulf of Guinea, and catching a phone that reported a location from
// somewhere the fleet does not drive.
const TH_BOUNDS = { minLat: 5.5, maxLat: 20.5, minLng: 97.3, maxLng: 105.7 }

function num (v) {
  if (v === '' || v == null) return null
  const n = Number(v)
  return isFinite(n) ? n : null
}

function inThailand (lat, lng) {
  const a = num(lat)
  const b = num(lng)
  if (a == null || b == null) return false
  return a >= TH_BOUNDS.minLat && a <= TH_BOUNDS.maxLat &&
         b >= TH_BOUNDS.minLng && b <= TH_BOUNDS.maxLng
}

function normalizeReport (report) {
  const r = report || {}
  return {
    kind: String(r.kind || '').trim(),
    name: String(r.name == null ? '' : r.name).trim(),
    brand: String(r.brand == null ? '' : r.brand).trim(),
    lat: num(r.lat),
    lng: num(r.lng),
    accuracy: num(r.accuracy),
    note: String(r.note == null ? '' : r.note).trim()
  }
}

// Errors are Thai because the driver reads them.
function validateReport (report) {
  const r = normalizeReport(report)
  const errors = []
  if (KINDS.indexOf(r.kind) === -1) errors.push('เลือกประเภทสถานี')
  if (!r.name) errors.push('ระบุชื่อสถานี')
  if (r.lat == null || r.lng == null) errors.push('ยังไม่ได้ตำแหน่ง กดใช้ตำแหน่งปัจจุบัน')
  else if (!inThailand(r.lat, r.lng)) errors.push('ตำแหน่งไม่ถูกต้อง ลองกดใช้ตำแหน่งปัจจุบันอีกครั้ง')
  return { ok: errors.length === 0, errors: errors }
}

module.exports = { KINDS, TH_BOUNDS, inThailand, normalizeReport, validateReport }
